<template>
  <div class="bottom-block">
    <div class="wrap">
      <terms-and-conditions
        :title="title"
        :content="text"
      />
      <div
        v-dompurify-html="noteText"
        class="please-note-block"
      />
      <print-button />
    </div>
  </div>
</template>
<script>
  import PrintButton from 'components/Buttons/PrintButton'
  import TermsAndConditions from 'components/TermsAndConditions'

  export default {
    components: {
      TermsAndConditions,
      PrintButton
    },
    props: {
      title: {
        type: String,
        required: false,
        default: ''
      },
      text: {
        type: String,
        required: false,
        default: ''
      },
      noteText: {
        type: String,
        required: false,
        default: ''
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .bottom-block {
    padding: 26px 0;
    text-align: center;

    @include bp-mf-tablet {
      padding: 44px 0;
    }

    .wrap {
      padding: 0 23px;

      @include bp-tablet-only {
        padding: 0 26px;
      }
    }

    .terms-and-conditions-block {

      ::v-deep .terms-and-conditions-panel-content {
        padding-left: 54px;
      }
    }

    ::v-deep .btn-print {
      position: inherit;
      margin: 26px auto 0;

      @media print {
        display: none;
      }

      @include bp-mf-tablet {
        margin-top: 44px;
      }
    }
  }

  .terms-and-conditions-block,
  .please-note-block {
    margin: 0 auto;
    max-width: 740px;
    text-align: left;

    ::v-deep p {
      margin: 0;
    }
  }

  .please-note-block {
    margin: 0 auto;
    padding: 26px 0;
    border-bottom: 1px solid $grey-border;
    font-size: em(14);
    line-height: 18px;

    @include bp-mf-tablet {
      padding: 44px 0;
      font-size: em(14);
      line-height: 21px;
    }

    ::v-deep a {
      color: $blue-medium;

      &:hover {
        @include bp-mf-tablet {
          color: $blue-light;
        }
      }
    }
  }
</style>
